import Vue from 'vue'

import App from './App'
import FpRouter from '@/router'
import FpStore from '@/store'

import components from '@/shared/components'
import plugins from '@/shared/plugins'
import storePlugins from '@/plugins'
import filters from '@/shared/filters'
import directives from '@/shared/directives'

import i18n from './i18n'

// Import css
import 'font-awesome/css/font-awesome.min.css'
import './shared/styles/styles.less'

// Vue component
components.forEach(c => Vue.component(c.name, c.component))

// Vue plugins
plugins.forEach(pl => Vue.use(pl.value, pl.options))
storePlugins.forEach(pl => Vue.use(pl.value, pl.options))

// Vue filters
filters.forEach(filter => Vue.filter(filter.name, filter.fn))

// Vue directives
directives.forEach(directive => Vue.directive(directive.name, directive.value))

for (let lang in i18n) {
  Vue.i18n.add(lang, i18n[lang])
}
Vue.i18n.fallback('en')

// Vue config
Vue.config.productionTip = true

new Vue({
  el: '#root',
  template: '<App/>',
  components: { App },
  router: FpRouter,
  store: FpStore
})
